export default {"src":"/_next/static/media/talantana.217aebe7.svg","height":120,"width":282,"blurWidth":0,"blurHeight":0};